import { z } from 'zod';
import { encryptedKeyByAesKeyValidator, encryptedKeyByRsaKeyValidator, publicKeyValidator, signedEntityByRsaKeyValidator, uuidValidator, } from '#validation';
export const CommonInvitationCreateSchema = z.object({
    id: uuidValidator({
        requiredError: 'invitation.id.required',
        formatError: 'invitation.id.uuid',
    }),
    publicKey: publicKeyValidator,
    ePrivateKeyByAdminKey: encryptedKeyByRsaKeyValidator,
    ePrivateKeyByInvitationSecret: encryptedKeyByAesKeyValidator,
    // this is optional since the invitation crete dto depends on it (used in the webservice endpoints)
    // and older clients would not be able to create invitations
    ePrivateKeyBySsoSecret: encryptedKeyByAesKeyValidator.optional(),
    eInvitationSecretByAdminKey: encryptedKeyByRsaKeyValidator,
    eWorkspaceCommonKeyByInvitationKey: encryptedKeyByRsaKeyValidator,
    eEveryonePrivateKeyByInvitationKey: encryptedKeyByRsaKeyValidator,
    sInvitationByAdminKey: signedEntityByRsaKeyValidator,
    sAdminPublicKeyByInvitationKey: signedEntityByRsaKeyValidator,
});
